export enum WhoAreYou {
  FINANCIAL_ADVISOR = 'Financial Advisor',
  INVESTOR = 'Investor',
  OTHER = 'Other',
}